import React, { useRef } from 'react';
import { useEnteredView } from '@fiverr-private/hooks';
import { I18n } from '@fiverr-private/i18n-react';
import { Container } from '@fiverr-private/layout_components';
import { Text } from '@fiverr-private/typography';
import { useYearsOnFiverr } from '../../../hooks/useYearsOnFiverr';
import { useBI } from '../../BIContext';

type YearsOnFiverrProps = Readonly<{
    sellerRoleId?: string;
}>;

export const YearsOnFiverr = ({ sellerRoleId }: YearsOnFiverrProps) => {
    const observableRef = useRef<HTMLDivElement>(null);
    const yearsOnFiverr = useYearsOnFiverr(sellerRoleId);
    const { reportSellerHighlightsExperienceImpression } = useBI();

    let yearsOnFiverrCopy: React.ReactNode;

    if (yearsOnFiverr < 1) {
        yearsOnFiverrCopy = <I18n k="seller_page_perseus.professions_page.highlights.years.less_than_year" />;
    } else {
        yearsOnFiverrCopy = (
            <I18n
                k={`seller_page_perseus.professions_page.highlights.years.${yearsOnFiverr === 1 ? 'one' : 'many'}`}
                params={{ count: yearsOnFiverr }}
            />
        );
    }

    useEnteredView(observableRef, {
        threshold: 1,
        onEntered: () => {
            reportSellerHighlightsExperienceImpression({ label: `${yearsOnFiverr}` });
        },
    });

    return (
        <Container ref={observableRef}>
            <Text
                size={{
                    default: 'b_lg',
                    md: 'b_xl',
                    lg: 'b_xxl',
                }}
                fontWeight="bold"
                marginBottom="1"
                whiteSpace="nowrap"
            >
                {yearsOnFiverrCopy}
            </Text>
            <Text size="b_sm" fontWeight="semibold" color="bodySecondary" whiteSpace="nowrap">
                <I18n
                    k={
                        sellerRoleId
                            ? 'seller_page_perseus.professions_page.highlights.experience'
                            : 'seller_page_perseus.professions_page.highlights.on_fiverr'
                    }
                />
            </Text>
        </Container>
    );
};
